import { projectType } from "../constants/projectType";

export const projectTypeOptions = [
  { label: "MuleSoft Integration", value: projectType.MULESOFT_INTEGRATION },
  { label: "MultiCloud", value: projectType.MULTI_CLOUD },
  { label: "MuleSoft/RPA/IDP", value: projectType.MULESOFT_RPA_IDP },
  { label: "Mulesoft EDI", value: projectType.MULESOFT_EDI },
  { label: "Hyper Automation", value: projectType.HYPER_AUTOMATION },
  { label: "Informatica Integration", value: projectType.INFORMATICA_INTEGRATION },
  { label: "Others", value: projectType.OTHERS },
 

];
